import { useEffect, useMemo } from 'react';
import { useTranslation } from '@jupiter/plugin-runtime/i18n';
import { useHistory } from 'react-router-dom';
import { ROLE_KEY, RoleType, RoleTypeMap } from '@/constants';
import { getQuery } from '@i18n-ecom/lib/dist/commonjs/url';
import { CODE_SUCCESS } from '@features/constants/network';
import { useUserModel } from '@/models';
import { useFeatureModel } from './models';

export const useFeatureGuide = () => {
  const { i18n } = useTranslation();
  const { location } = useHistory();
  const { roleType: oriRoleType } = useUserModel(({ roleType }) => [roleType]);
  const { menu, init } = useFeatureModel();
  const roleType = useMemo(() => {
    return RoleTypeMap[
      getQuery(location.search, ROLE_KEY)?.toString() ||
        oriRoleType ||
        RoleType.Seller
    ];
  }, []);
  const wait = async () => {
    const res = await init(roleType);

    // lazyload
    setTimeout(() => {
      handleChange(
        roleType === RoleType.Seller ? RoleType.Creator : RoleType.Seller,
      );
    }, 300);

    return res?.code === CODE_SUCCESS;
  };
  const handleChange = (type: RoleType) => {
    if (!menu[type].length) {
      init(type);
    }
  };

  useEffect(() => {
    init(RoleType.Seller);
    init(RoleType.Creator);
  }, [i18n.language]);

  return {
    wait,
    handleChange,
  };
};
